module.exports = __webpack_public_path__ + "img/damir_jugo1.5a81815d.jpg";